import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './BusinessListingPage.css';

export default function BusinessListingPage() {
  const { categoryName, subCategoryName } = useParams();
  const navigate = useNavigate();
  const category = decodeURIComponent(categoryName);
  const subCategory = decodeURIComponent(subCategoryName);

  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState('');
  const [businessType, setBusinessType] = useState('');
  const [rating, setRating] = useState('');

  useEffect(() => {
    setLoading(true);
    api.get('/api/businesses', {
      params: { category, subCategory, sortBy, businessType, minRating: rating }
    })
      .then(res => setBusinesses(res.data.data?.businesses || []))
      .catch(() => setBusinesses([]))
      .finally(() => setLoading(false));
  }, [category, subCategory, sortBy, businessType, rating]);

  const clearFilters = () => { setSortBy(''); setBusinessType(''); setRating(''); };

  const filtered = businesses;

  return (
    <div className="blp-page">

      {/* ── Banner ── */}
      <div className="blp-banner">
        <div className="blp-banner-text">
          <h1>Promote Your<br /><span>Business</span><br />in Your District<br />with AdSet</h1>
          <p>Advertise in the right place,<br />reach the right people.</p>
          <button onClick={() => navigate('/adset')}>Start Now</button>
        </div>
        <div className="blp-banner-visual">
          <div className="blp-phone-mockup">
            <div className="blp-phone-screen">
              <div className="blp-phone-search">🔍 Search Business here</div>
              <div className="blp-phone-cats">
                {['🍽️ Restaurants','🏪 Shops','⚙️ Services','🏥 Health','🎓 Education','🔧 Plumber'].map((c,i)=>(
                  <div key={i} className="blp-phone-cat">{c}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blp-container">

        {/* Breadcrumb */}
        <div className="blp-breadcrumb">
          <span onClick={() => navigate('/')}>Home</span>
          <span>›</span>
          <span onClick={() => navigate(`/category/${encodeURIComponent(category)}`)}>{category}</span>
          <span>›</span>
          <span className="active">{subCategory}</span>
        </div>

        {/* Filters */}
        <div className="blp-filters">
          <select value={sortBy} onChange={e => setSortBy(e.target.value)}>
            <option value="">Sort By</option>
            <option value="rating">Top Rated</option>
            <option value="newest">Newest</option>
            <option value="popular">Most Popular</option>
          </select>
          <select value={businessType} onChange={e => setBusinessType(e.target.value)}>
            <option value="">Business Type</option>
            <option value="Trader">Trader</option>
            <option value="Manufacturer">Manufacturer</option>
            <option value="Service Provider">Service Provider</option>
            <option value="Seller">Seller</option>
          </select>
          <select value={rating} onChange={e => setRating(e.target.value)}>
            <option value="">Ratings</option>
            <option value="5">5 ★</option>
            <option value="4">4★ & above</option>
            <option value="3">3★ & above</option>
          </select>
          <button className="blp-clear-btn" onClick={clearFilters}>Clear Filters</button>
        </div>

        {/* Business List */}
        <div className="blp-list">
          {loading ? (
            <div className="blp-empty"><span>⏳</span><p>Loading businesses...</p></div>
          ) : filtered.length === 0 ? (
            <div className="blp-empty"><span>🔍</span><p>No businesses found in this category</p></div>
          ) : (
          filtered.map(b => (
              <div key={b._id} className="blp-card">
                <div className="blp-card-body">
                  <div className="blp-card-img">
                    {b.logo
                      ? <img src={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/${b.logo}`} alt={b.businessName} />
                      : <span>🏢</span>
                    }
                  </div>
                  <div className="blp-card-info">
                    <div className="blp-name-row">
                      <h3 onClick={() => navigate(`/business/${b._id}`)}>{b.businessName}</h3>
                      {b.verified && <span className="blp-verified">Verified Business</span>}
                    </div>
                    <p className="blp-desc">{b.businessType}{b.established ? ` | Since ${b.established}` : ''}</p>
                    <div className="blp-rating">
                      {'★'.repeat(Math.round(b.rating || 0))}{'☆'.repeat(5 - Math.round(b.rating || 0))}
                      <span>{b.reviews || 0} Reviews</span>
                    </div>
                    <p className="blp-address">📍 {b.address || b.fullAddress || b.city || ''}</p>
                    {b.logistryEnabled && b.deliveryRange && (
                      <p className="blp-delivery">🚚 &nbsp;{b.deliveryRange} Km Delivery</p>
                    )}
                    <div className="blp-actions">
                      <a href={`tel:${b.phone}`} className="blp-btn call">Call Now</a>
                      <button className="blp-btn enquiry" onClick={() => navigate(`/business/${b._id}`)}>Enquiry</button>
                      {b.website && <a href={b.website} target="_blank" rel="noreferrer" className="blp-btn website">Website</a>}
                      {b.whatsapp && <a href={`https://wa.me/${b.whatsapp}`} target="_blank" rel="noreferrer" className="blp-btn whatsapp">WhatsApp</a>}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

      </div>
    </div>
  );
}
